const reportNotInDB = [
  { value: 0, text: 'របាយការណ៏តារាងជំរឿនស្ថិតិសាលារៀនចំណេះទូទៅសាធារណៈ' },
  { value: 25, text: 'របាយការណ៏សៀវភៅសិក្សាគោល' },
  { value: 31, text: 'របាយការណ៏តារាងពិន្ទុតាមមុខវិជ្ជា' }
]

const reportNotInDBPriv = [
  { value: 0, text: 'របាយការណ៏តារាងជំរឿនស្ថិតិមត្តេយ្យសិក្សាសហគមន៏' },
  //{ value: 1, text: 'របាយការណ៏តារាងជំរឿនស្ថិតិសាលារៀនមត្តេយ្យសិក្សាចំណេះទូទៅឯកជន' },
  //{ value: 2, text: 'របាយការណ៏តារាងជំរឿនស្ថិតិសាលារៀនបឋមសិក្សាចំណេះទូទៅឯកជន' },
  //{ value: 3, text: 'របាយការណ៏តារាងជំរឿនស្ថិតិសាលារៀនមធ្យមសិក្សាចំណេះទូទៅឯកជន' }
  { value: 3, text: 'របាយការណ៏តារាងជំរឿនស្ថិតិសាលារៀនចំណេះទូទៅឯកជន' }
]

const qReportConfig = [
  {
    vtabText: "Public ASCF",
    lfile: [
      { value: 10, text: '00.សាលាមតេ្តយ្យដាច់ដោយឡែក', outFormat: 'XLSX', outFile: '00.seperate_pre_school.XLSX' },
      { value: 11, text: '01.កម្រងសាលារៀនតាមរាជធានីខេត្ត', outFormat: 'XLSX', outFile: '01.primary_cluster.XLSX' },
      { value: 12, text: '02.ព័តមានសង្ខេប សាលាមត្តេយ្យសិក្សា', outFormat: 'XLSX', outFile: '02.pre_basic_statistic.XLSX' },
      { value: 13, text: '03.ព័តមានសង្ខេប សាលាបឋមសិក្សា', outFormat: 'XLSX', outFile: '03.pri_basic_statistic.XLSX' },
      { value: 14, text: '04.ព័តមានសង្ខេបមធ្យមសិក្សា', outFormat: 'XLSX', outFile: '04.sec_basic_statistic.XLSX' },
      { value: 15, text: '05.សូចនាករចូលរៀន និង សមធម៌', outFormat: 'XLSX', outFile: '05.er1910.XLSX' },
      { value: 16, text: '06.អត្រារួម និង អត្រាពិតនៃការសិក្សា', outFormat: 'XLSX', outFile: '06.er1911.XLSX' },
      { value: 17, text: '07.អត្រាចូលរៀនថ្មី និងអត្រានៃការសិក្សាសិស្សប្រុស', outFormat: 'XLSX', outFile: '07.er1912.XLSX' },
    ]
  },
]

export {
  reportNotInDB,
  reportNotInDBPriv,
  qReportConfig
}
